const state = {
    labels: {}
};

const mutations = {
    setLabels(state, data) {
        state.labels = data;
    }
};

export default {
    state,
    mutations
};
